/**
 * Dev-only verbose logger.
 *
 * Active when Vite is running in dev mode (`import.meta.env.DEV`), no-op
 * in the production bundle. Use it to sprinkle high-signal traces near
 * suspected bugs so the user can paste console output back when something
 * weird happens (combat freezes, stuck tweens, missed transitions).
 *
 * Convention: `devLog("namespace:event", data?)` — namespace mirrors the
 * EventBus naming so logs read consistently.
 */

const enabled = import.meta.env.DEV;

export function devLog(kind: string, ...data: readonly unknown[]): void {
  if (!enabled) return;
  if (data.length === 0) {
    console.log(`[bk] ${kind}`);
  } else {
    console.log(`[bk] ${kind}`, ...data);
  }
}

export const devLogEnabled = enabled;
